export function validateOrderItemsAgainstInventory(orderItems, inventory) {
	if (!Array.isArray(orderItems) || orderItems.length === 0) {
		return { validItems: [], missingSkus: [], hasErrors: true };
	}

	if (!Array.isArray(inventory) || inventory.length === 0) {
		return {
			validItems: [],
			missingSkus: orderItems.map((item) => item.sku),
			hasErrors: true,
		};
	}

	const inventoryBySku = new Map(inventory.map((stockItem) => [stockItem.sku, stockItem]));
	const validItems = [];
	const missingSkus = [];

	orderItems.forEach((item) => {
		const inventoryItem = inventoryBySku.get(item.sku);

		if (!inventoryItem) {
			missingSkus.push(item.sku);
			return;
		}

		validItems.push({
			...item,
			product_id: inventoryItem.product_id,
		});
	});

	return {
		validItems,
		missingSkus,
		hasErrors: missingSkus.length > 0,
	};
}

export function missingOrderItemsMessage(missingSkus) {
	return `The following SKU(s) "${missingSkus.join(", ")}" were not found in your inventory and therefore cannot be processed`;
}

export function computeTotalOrderItems(items) {
	if (!Array.isArray(items) || items.length === 0) {
		return 0;
	}

	return items.reduce((total, item) => total + (Number(item.quantity) || 0), 0);
}

export function displayTotalOrderItems(items, apiTotal) {
	if (Array.isArray(items)) {
		return computeTotalOrderItems(items);
	}

	return apiTotal ?? 0;
}

export async function loadSellerWarehouseInventory(dataProvider, sellerID, warehouseID) {
	const PAGE_SIZE = 500;
	let allStock = [];
	let page = 1;
	let total = null;

	do {
		const response = await dataProvider.getStock(
			sellerID, warehouseID, false, 0, { page, results: PAGE_SIZE }
		);
		const stock = response.data.stock ?? [];
		if (total === null) {
			total = response.data.total;
		}
		if (stock.length === 0) {
			break;
		}
		allStock.push(...stock);
		page++;
	} while (allStock.length < total);

	return allStock;
}
